/**
 * Removes all the spaces from the strings and puts it in to the format:
 * "# ###### ######"
 */
export const barcodeFormatter = (value: string) => {
  value = value.replace(/\s/g, "");
  if (value.length > 1) value = value.slice(0, 1) + " " + value.slice(1);
  if (value.length > 8) value = value.slice(0, 8) + " " + value.slice(8);

  return value;
};
